import { httpClient } from '../http/httpClient'

export interface UpdateCpfBody {
  cpf: string
}

export async function updateCpf(id: string, body: UpdateCpfBody) {
  const { data } = await httpClient
    .put<{ success: boolean }>(`user/${id}`, body)
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
